export default "__VITE_ASSET__EkeP74bZ__"